import React, { useEffect } from 'react'
import useFetch from './hook/useFetch';

const TestPage:React.FC = () => {
    const {data}:any = useFetch("Ticktet", "GetTicketById", { userId: parseInt(JSON.parse(localStorage.getItem('userID')!)) });


    useEffect(() => {
        console.log(data)
        debugger
      }, [data]);
    const checking = () => {
        debugger;
        console.log(data)
    }
    return (
      <>
      <div className='sadasd'>
        <button onClick={checking}>dsadsa</button>
      </div>
        {data &&
          data.map((item:any) => {
            return <div>a</div>;
          })}
      </>
    );
}


export default  TestPage;